import {
  Box,
  HStack,
  Text,
  Tooltip,
  VStack,
  Icon,
  Spinner,
} from "@chakra-ui/react";
import { FiInfo } from "react-icons/fi";
import { dineroFormatCurrency } from "src/utils";

interface PreviewCardProps {
  preview: {
    faceValue: number;
    fees: number;
    rebate: number;
    finalPrice: number;
    isLoading?: boolean;
  };
}

export const PreviewCard = ({ preview }: PreviewCardProps) => {
  return (
    <Box flex={1} bg="white" borderRadius="lg">
      <VStack align="flex-start" spacing={1}>
        <HStack
          spacing={2}
          w="full"
          borderBottom="1px solid"
          borderColor="gray.200"
          py={2}
          px={4}
        >
          <Text
            fontSize="xl"
            fontWeight="medium"
            textAlign="center"
            w="full"
            color={preview.isLoading ? "gray.400" : "gray.900"}
            flex={1}
          >
            {preview.finalPrice > 0
              ? dineroFormatCurrency(preview.finalPrice)
              : "—"}
          </Text>
          {preview.isLoading && <Spinner size="sm" />}
        </HStack>
        <VStack
          align="flex-start"
          spacing={0}
          fontSize="sm"
          px={4}
          py={2}
          w="full"
        >
          <HStack spacing={1} justifyContent="space-between" w="full">
            <HStack>
              <Text color="gray.500" fontSize="sm">
                FV:
              </Text>
              <Text color="gray.500" fontSize="sm">
                {dineroFormatCurrency(preview.faceValue)}
              </Text>
            </HStack>

            <Box>
              <Tooltip
                label={
                  <VStack spacing={0}>
                    {preview?.faceValue > 0 && (
                      <Text fontSize="sm">
                        Face Value: ({dineroFormatCurrency(preview?.faceValue)})
                      </Text>
                    )}
                    {preview?.fees > 0 && (
                      <Text fontSize="sm">
                        Fees: ({dineroFormatCurrency(preview?.fees)})
                      </Text>
                    )}
                    {preview?.rebate > 0 && (
                      <Text fontSize="sm">
                        Rebate: ({dineroFormatCurrency(preview?.rebate)})
                      </Text>
                    )}
                  </VStack>
                }
                placement="bottom"
              >
                <span>
                  <Icon as={FiInfo} boxSize={3} color="gray.500" />
                </span>
              </Tooltip>
            </Box>
          </HStack>
          <HStack spacing={1}>
            <Text color="gray.500" fontSize="sm">
              Fees:
            </Text>
            {preview.isLoading ? (
              <Spinner size="xs" />
            ) : (
              <Text color="gray.500" fontSize="sm">
                {preview.fees > 0 ? dineroFormatCurrency(preview.fees) : "—"}
              </Text>
            )}
          </HStack>
          <HStack spacing={1}>
            <Text color="gray.500" fontWeight="medium" fontSize="sm">
              Rebate:
            </Text>
            <Text color="gray.500" fontWeight="medium" fontSize="sm">
              {preview.rebate > 0 ? dineroFormatCurrency(preview.rebate) : "—"}
            </Text>
          </HStack>
        </VStack>
      </VStack>
    </Box>
  );
};
